/**
 * How a license controls single logout (SLO) for its users.
 * Maps to `LicenseSamlAuthenticationSettings.IdpLogout`, which is null when each user decides.
 */
export enum LicenseIdpLogoutMode {
  User = 'user',
  Always = 'always',
  Never = 'never'
}
